(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('statement', {
            parent: 'entity',
            url: '/statement?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.statement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/statement/statements.html',
                    controller: 'StatementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('statement-detail', {
            parent: 'entity',
            url: '/statement/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.statement.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/statement/statement-detail.html',
                    controller: 'StatementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statement');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Statement', function($stateParams, Statement) {
                    return Statement.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'statement',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('statement-detail.edit', {
            parent: 'statement-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/statement/statement-dialog.html',
                    controller: 'StatementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Statement', function(Statement) {
                            return Statement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('statement.new', {
            parent: 'statement',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/statement/statement-dialog.html',
                    controller: 'StatementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dtIns: null,
                                amount: null,
                                idUser: null,
                                balance: null,
                                queueId: null,
                                description: null,
                                type: null,
                                sign: null,
                                externalRefId: null,
                                campaignId: null,
                                agencyId: null,
                                currency: null,
                                bo_user_id: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('statement', null, { reload: 'statement' });
                }, function() {
                    $state.go('statement');
                });
            }]
        })
        .state('statement.edit', {
            parent: 'statement',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/statement/statement-dialog.html',
                    controller: 'StatementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Statement', function(Statement) {
                            return Statement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('statement', null, { reload: 'statement' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('statement.delete', {
            parent: 'statement',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/statement/statement-delete-dialog.html',
                    controller: 'StatementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Statement', function(Statement) {
                            return Statement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('statement', null, { reload: 'statement' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
